var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoBenutzerverwaltung(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473.64 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7b68b;}.cls-2{fill:#ec9568;}.cls-3{fill:#7eb3ff;}.cls-4{fill:#b0bfde;}.cls-5{fill:#acd4f8;}.cls-6{fill:#d4edff;}.cls-7{fill:#c5e1f9;}.cls-8{fill:#163f59;}.cls-9{fill:#212957;}.cls-10{fill:#194866;}.cls-11{fill:#9ac7f7;}.cls-12{fill:#387bff;}.cls-13{fill:#3b47bc;}.cls-14{fill:none;stroke:#7eb3ff;stroke-miterlimit:10;stroke-width:.37px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "236.82 141.9 473.64 228.83 473.64 362.02 0 362.02 0 228.83 236.82 141.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "236.82 450 473.64 363.07 473.64 229.88 236.82 316.81 236.82 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "236.82 450 0 363.07 0 229.88 236.82 316.81 236.82 450"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m298.06,50.05s-3.62,5.71-7.57,6.01c-3.95.3-5.93-9.01-5.93-15.32s6.91-12.32,7.57-14.12c.66-1.8,7.57,4.21,7.57,9.61s-1.65,12.32-1.65,13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m267.89,102.26l-15.91,26.95s1.03,4.62,3.59,2.05c2.57-2.57,17.44-19.25,17.44-19.25,0,0,4.63-15.66-5.12-9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m256.86,128.19s-1.28,5.13-1.8,7.7c-.51,2.57-3.08,9.5-4.11,10.52l-1.03,1.03,1.8-6.55-1.93,2.31s-1.03,3.85-1.41,4.36c-.39.51-1.03.77-1.03.77-1.28.64-1.54-.13-1.54-.13l.9-4.88,1.41-3.59-2.31,2.18s-.51,4.11-.9,4.49c-.39.38-1.28.13-1.28.13l.9-5.77,3.72-5.39s-.77-.38-1.67.77c-.9,1.15-1.8,1.67-2.44,1.67s1.8-3.34,2.44-3.85c.64-.51,1.67-3.72,4.49-4.62,2.82-.9,5.77-1.15,5.77-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m293.03,247.19l1.71,9.24h-26.18s-.17-2.91,2.91-3.76c3.08-.86,11.46-3.42,13.69-6.16,2.22-2.74,7.87.68,7.87.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m327.17,247.19l1.71,9.24h-26.18s-.17-2.91,2.91-3.76c3.08-.86,11.46-3.42,13.69-6.16,2.22-2.74,7.87.68,7.87.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m319.75,246.51l-28.87-89.76-.65-42.43v-2.31l14.63.26s9.24,10.01,8.98,23.1c-.26,13.09-.77,42.61,1.28,48.25,2.05,5.65,7.44,15.14,7.96,21.05.51,5.9,3.08,41.32,3.08,41.32l-6.42.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m278.15,112.53s-5.13,8.73-3.85,24.13c1.28,15.4,11.29,109.34,11.29,109.34l7.7.26s2.57-35.93,1.54-44.66c-1.03-8.73-3.85-17.71-3.59-19.25.26-1.54,14.12-49.02,13.09-53.13-1.03-4.11-6.16-16.68-6.93-16.94-.77-.26-19.25.26-19.25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m278.92,117.66s-.51,50.56,2.57,64.17c3.08,13.6,6.16,52.36,6.16,58.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m312.8,65.3s6.42,5.13,1.28,20.28c-5.13,15.14-7.19,23.36-8.21,23.61-1.03.26-6.42,1.28-8.21-.77-1.8-2.05-3.34-3.85-3.08-5.13.26-1.28,6.04-33.92,6.67-36.96,1.28-6.16,9.75-1.8,11.55-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m280.97,66.59l7.44-3.85,13.86-.26s7.19,1.03,10.27,7.7c1.06,2.3-2.43,35.71-1.8,40.3.9,6.44,5.3,13.78-4.98,14.51-20.52,1.47-29.38-7.34-29.38-7.34,0,0-.55-46.95,4.58-51.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m282.26,67.1s6.42,5.13,1.28,20.28c-5.13,15.14-7.19,23.36-8.21,23.61-1.03.26-6.42,1.28-8.21-.77-1.8-2.05-3.34-3.85-3.08-5.13.26-1.28,10.27-29,11.55-31.83,1.28-2.82,4.88-6.93,6.67-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m304.07,48.88l-1.03,13.86s.53,1.93-3.85,2.31c-5.9.51-8.47-1.8-8.47-1.8,0,0,3.34-6.42,2.82-15.14-.51-8.73,10.52.77,10.52.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m293.81,22.95s7.5-1.8,14.89,3.85c4.36,3.34,6.93,9.24,4.62,14.12-2.31,4.88-7.44,11.29-10.01,11.29s-8.21-3.85-8.98-5.39c-.77-1.54-.77-2.57-1.28-5.9-.51-3.34-2.31-2.31-2.31-1.54s-1.03,3.08-1.54,1.54c-.51-1.54-11.04-12.58,4.62-17.97Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 310.11,
    cy: 23.72,
    rx: 11.16,
    ry: 10.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m267.89,102.26l-15.91,26.95s1.03,4.62,3.59,2.05c2.57-2.57,17.44-19.25,17.44-19.25,0,0,4.63-15.66-5.12-9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m165.14,245.7c.36.48.09,1.76.09,1.76,0,0-6.36.8-8.4.28-.53-.14-1.43-.63-2.27-1.16-.14-.09-.39-.62-.53-.71-.26-.17-.39.11-.61-.04-.57-.39-.96-.69-.97-.73-.55-3.2.2-4.49.2-4.49,0,0,5.42-1.99,6.43-.62,2.38,3.23,5.27,4.66,6.06,5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.65,241.54l.94,5.17h2.48s.28-.73.7-.73c.36,0,.82.73,1.31.73h12.79s.23-1.09-.05-1.46c-.14-.19-.98-.53-1.55-.69-2.6-.77-10.03-3.16-11.32-5.76-1.57-3.17-5.31,2.75-5.31,2.75Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "164.03 127.64 158.73 124.69 158.1 124.03 158.84 122.85 160 122.99 159.8 119.54 165.35 118.55 168.2 117.22 165.57 126.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m188.6,43.43s-5.94,6.54,12.35,23.82c18.29,17.28,21.62,12.22,21.62,12.22l5.53-3.68,4.1-19.22-8.83-2.05-.96,1.13s-1.9.19-2.85-1.16c-.95-1.35-7.01-5.9-15.74-17.13-4.03-5.18-14.08,4.8-15.21,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.74,57.67s18.45-.34,19.92-19.54c.44-5.71,1.9-.19,2.9,5.27,1.01,5.45-2.36,20.82-12.22,26.99-9.85,6.17-14.07,7.69-17.87,5.17-3.81-2.51,7.27-17.89,7.27-17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.53,241.57s-2.86,4.15-4.97.27c-4.86-8.95-12.07-31.06-12.32-41.12-.35-14.43,2.1-24.46,2.1-24.46l15.38-5.02-.19,70.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.02,105.11l.7,66.12-13.98,7.72s-8.39-15.78-9.44-35.91c-.45-8.55-.66-27.73,4.12-34.25,6.48-8.84,18.6-3.68,18.6-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m197.92,105.11l-2.29,22.89-6.21,24.83-6.61,23.2-23.61,64.41-6.87.56s.87-48.35,9.25-62.45c4.44-7.46,4.43-24.02,6.48-41.85.37-3.21-1.45-10.47-1.16-13.4,1.16-11.56,7.11-20.21,7.11-20.21l23.91,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m203.25,106.11l-30.28-.67-12.93-43.3s-8.39-26.18,7.69-26.52c16.08-.34,34.6-.34,34.6-.34,0,0,13.28,24.42.93,70.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.91,93.46l19.18,23.34s-.69,3.4-2.23,1.59c-.19-.22.74-.9-.43-1.54-4.71-2.57-15.78-6.53-19.87-10.49-5.39-5.21-9.22-11.33-9.22-11.33l12.57-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m186.8,41.37s14.09,27.86,10.09,58.7c-.31,2.43-2.84,4.17-2.84,4.17l-3.47-3.47s.28-34.9-3.78-59.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "186.29 40.73 185.53 46.09 176.32 37.37 176.32 36.03 186.29 40.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "189.19 37.26 190.81 44.25 186.72 40.73 189.19 37.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m216.5,60.96l2.4-4.34,1.06-1.68c1,.87,2.45.73,2.45.73l-2.39,2.9-2.19,3.93-1.24,5.99-.09-7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m161.5,61.38l-10.53,30.33-2.28.91,1.27,2.02-12.99,2.26-5.71-9.91,15.17-41.17s5.86-8.65,18.93-10.09c9.47-1.04-3.1,23.13-3.85,25.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.17,89.85s8.86,1.66,13.51,2.36l-1,.4,1.27,2.02-4.5.74-6.55.15-1.02-2.42,1.91-.48-3.63-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.18,29.54c.35,1.66.96,4.24,1.63,5.75,1.05,2.35,10.13,5.37,11.53,5.71,1.4.33-.35-7.05-.35-8.73,0-1.28-.83-.88.17-2.73h-12.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m190.71,25.81c.23,1.44-.75,2.79-2.19,3.02l-11.72,1.88c-1.44.23-2.79-.75-3.02-2.19l-2.78-17.36c-.23-1.44.75-2.79,2.19-3.02l11.72-1.88c1.44-.23,2.79.75,3.02,2.19l2.79,17.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.52,12.02s1.3-1.93,1.43-3.01c.06-.55-.76-2.44-2.19-2.99-1.42-.55-2.28,1.03-2.28,1.03,0,0,2.26.82,2.44,1.24.18.42.6,3.73.6,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m171.06,19.16s-2.84-6.39-2.83-8.4c.01-2.01.01-3.4,2.36-4,3.52-.9,3.69-.15,5.25-1.51,1.56-1.36,4.26-4.48,5.3-4.91,1.72-.72,4.62-.57,5.27,2.77.48,2.47,2.14,2.83,2.12,2.93-.09.33-.7.72-1.74,1.47-2.99,2.15-4.89,2.79-7.49,2.54-2.6-.25-7.48-.92-7.72,1.02-.25,1.93.87,7.54.73,8.01-.15.47-.74.34-1.23.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.58,23.78c.08.48-.25.93-.73,1.01l-2.53.41c-.48.08-.93-.25-1.01-.73l-.74-4.63c-.07-.48.25-.93.73-1.01l2.53-.41c.48-.08.93.25,1.01.73l.75,4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.89,16.16h2.56c.48,0,.88.39.88.88v4.69c0,.49-.39.88-.88.88h-2.56c-.49,0-.88-.39-.88-.88v-4.69c0-.48.39-.88.88-.88Z",
    transform: "translate(-.69 30.06) rotate(-9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m172.42,20.5s1.1,6.83,1.46,9.11c.33,2.06,1.88,6.45,13.51,4.58,6.89-1.11,5.82-6.13,5.56-7.79-.2-1.27-2.24-4.83-3.09-5.44-.03-.02.45,2.82.45,2.82,0,0-1.87-2.52-5.15-1.99-5.28.85-5.99,4.13-8.33,4.45-1.8.25-3.61-2.46-4.42-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.72,26.63l3.62-.58c.48-.08.8-.53.73-1.01l-.08-.5-5.35.86.08.51c.08.48.53.81,1.01.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.38,41.36s-1.74-5.9-.84-7.38c.9-1.47,4.54-6.62,4.54-6.62l1.04-1.22s1.89.49-.59,3.92c-2.48,3.44-.42,2.47-.42,2.47l3.34-2.19,4.3-2.34,1.78-1.3s.96-.82,1.34-.8c1.11.04.66.94.66.94l-6.53,5.69,7.35-3.49s1.01-.28,1.33.2c.29.45,0,.62,0,.62l-7.45,6.05,3.98-1.34s1-.24,1.33.21c.36.49.47.62.47.62l-14.67,7.44-.96-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m260.04,33.7l5.3-2.13s1.14-.62,1.83-.55c.79.08.76.82.76.82l-7.7,4.06-.19-2.2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoBenutzerverwaltung);
export default __webpack_public_path__ + "static/media/Demo_Benutzerverwaltung.6b8fd1a09363616cbe655b96ca8b43b1.svg";
export { ForwardRef as ReactComponent };